import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
import * as Access from '@app/models/access';
import { VersionFeedback } from '@core/models/version-feedback';

@Injectable({
  providedIn: 'root'
})
export class ProjectsRequests {
	private readonly prefix = "/requests";
	private readonly projects_prefix = "/projects";

    constructor(private http: HttpClient, private urlSrv : UrlService) {}

    public load$(id: number): Observable<HttpResponse<Objects.Request>> {
        return this.http.get<Objects.Request>(
            this.urlSrv.build(`${this.projects_prefix}/${id}`),
            { observe: 'response' }
        );
    }

    public loadFiles$ = (id: number) : Observable<Objects.File[]> =>
        this.http.get<Objects.File[]>(this.urlSrv.build(this.projects_prefix + "/" + id + "/files"));

    public loadOrigin$ = (id: number) : Observable<Objects.Version[]> =>
        this.http.get<Objects.Version[]>(this.urlSrv.build(this.prefix + "/" + id + "/versions"), {params: {origin: 'true', uploads: 'false'}});

    public setInfo$ = (id: number, info: string) =>
        this.http.post(this.urlSrv.build(this.projects_prefix+"/"+id+"/info"), {content: info}); 

    public deleteFile$ = (id: number, file: Objects.File) =>
        this.http.delete(this.urlSrv.build(this.projects_prefix+"/"+id+"/files/" + file.id ));

    public addFiles$ = (id: number, files: Array<Objects.File>) =>
        this.http.post<Objects.File[]>(this.urlSrv.build(this.projects_prefix+"/"+id+"/files"), {files: files.map((file: Objects.File) => file.id)}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public loadAssigners$ = (id: number) =>
        this.http.get<Objects.User[]>(this.urlSrv.build(this.prefix + "/" + id + "/allowed-users"));

    // Probably not used more...
    /**
     * @deprecated detected as not used on 15/04/2024 <diego@twonas.com>    
     * @param id identifier of origin status.
     * @returns transitions array for given origin status id
     */
    public loadWorkflowTransitionsByOrigin$ = (id: number) =>
        this.http.get<Objects.WorkflowTransition[]>(this.urlSrv.build("/workflows/transitions?origin=" + id));

    public loadWorkflowTransitions$ = () =>
        this.http.get<Objects.WorkflowTransition[]>(this.urlSrv.build("/workflows/transitions"));

    public loadAccess$ = (id: number) =>
        this.http.get<Access.AccessProject>(this.urlSrv.build(this.prefix + "/" + id + "/permissions"));

    public loadMessages$ = (id: number) =>
        this.http.get<Objects.Message[]>(this.urlSrv.build(this.prefix + "/" + id + "/messages"));

    public loadRelated$ = (id: number)  =>
        this.http.get<Objects.Version[]>(this.urlSrv.build(this.projects_prefix + "/" + id + "/versions/related"));

    public loadVersionGroups$ = (id: number) =>
        this.http.get<Objects.Related[]>(this.urlSrv.build(this.prefix + "/" + id + "/versions/links"));

    public loadVersionGroupsVersions$ = (groupLink: string) =>
        this.http.get<Objects.Version[]>(this.urlSrv.build("/versions"),{params: {link: groupLink}});

    // load type request and version. Here we still have pure Objects.Event that will be fille as LogbookEvent in the reducer.
    public loadEvents$ = (object: string, id: number) => 
        this.http.get<Objects.Event[]>(this.urlSrv.build("/events"), {params: {q: object+':'+id }});

    public loadUploadedVersions$ = (id: number) : Observable<Objects.Version[]> =>
        this.http.get<Objects.Version[]>(this.urlSrv.build(this.prefix + "/" + id + "/versions"), {params: {origin: 'false', uploads: 'true'}});

    public setAssign$ = (id: number, user: Objects.User) =>
        this.http.put<Objects.Request>(this.urlSrv.build(this.projects_prefix+"/"+id ), {assigned: user!=null? user.id : null}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public setDue$ = (id: number, date: string) =>
        this.http.put<Objects.Request>(this.urlSrv.build(this.projects_prefix+"/"+id ), {due_date: date}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public setStatus$ = (id: number, status: Objects.RequestStatus) =>
        this.http.put<Objects.Request>(this.urlSrv.build(this.projects_prefix+"/"+id ), {status: status.id}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    public setLabels$ = (id: number, labels: Array<Objects.Label>) =>
        this.http.put<Objects.Request>(this.urlSrv.build(this.projects_prefix+"/"+id ), {labels: labels.map((l: Objects.Label) => l.id)}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

    // new annotations counter
    public loadFilesNotesCounter$ = (id: number) =>
        this.http.get<Objects.AnnotationsCounter[]>(this.urlSrv.build(this.projects_prefix + "/" + id + "/annotations"));
    
    public getRelatedFeedbacks$ = (versions: Objects.Version[]) : Observable<VersionFeedback[]> => {
        return this.http.get<VersionFeedback[]>(
            this.urlSrv.build("/p/feedback/versions/feedbacks/"+versions.map((v: Objects.Version) => v.id).join('-')));
    }

    public setVersionStatus$ = (id: number, status: Objects.Status) => 
        this.http.put<Objects.Version>(this.urlSrv.build("/versions/"+id ), {status: status.id}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

}
